"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractBoolSettingsValue = exports.extractIntSettingsValue = void 0;
const isNaN_1 = __importDefault(require("lodash/isNaN"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
function extractIntSettingsValue(settings, name, defaultValue, min = null, max = null) {
    const parsed = parseInt(settings[name]);
    if ((0, isNaN_1.default)(parsed)) {
        return defaultValue;
    }
    if ((0, isNumber_1.default)(parsed)) {
        if (min != null && parsed < min)
            return min;
        if (max != null && parsed > max)
            return max;
        return parsed;
    }
    return defaultValue;
}
exports.extractIntSettingsValue = extractIntSettingsValue;
function extractBoolSettingsValue(settings, name, defaultValue) {
    const res = settings[name];
    if (res == null)
        return defaultValue;
    return !!res;
}
exports.extractBoolSettingsValue = extractBoolSettingsValue;
